import React from "react";

const SuccessModal = ({ showSuccess, setShowSuccess }) => {
  if (!showSuccess) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4 z-50">
      <div className="bg-gray-900 p-8 rounded-2xl max-w-md w-full mx-4 border border-gray-700 text-center">
        <div className="mb-6">
          <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h3 className="text-2xl font-bold text-white mb-2">Success!</h3>
          <p className="text-gray-300">
            Your demo has been booked successfully! We'll be in touch with you soon to schedule your personalized demonstration.
          </p>
        </div>
        
        <div className="bg-gray-800/50 p-4 rounded-lg mb-6">
          <p className="text-sm text-gray-300">
            <strong className="text-[hsl(30,100%,85%)]">What's next?</strong><br />
            • Our team will reach out within 24 hours<br />
            • Free audit of your current tech-stack<br />
            • Site set-up and admin access for free!
          </p>
        </div>
        
        <button
          onClick={() => setShowSuccess(false)}
          className="w-full bg-[hsl(30,100%,85%)] text-black px-6 py-3 rounded-lg hover:bg-white transition-colors font-medium"
        >
          Got it, thanks!
        </button>
      </div>
    </div>
  );
};

export default SuccessModal; 